import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk';
import RequestService, {
    RequestServiceResponse,
} from '@tcc-online/request-service';
import { NotificationActions } from '../../common/actions/NotificationActions';
import ProjectTranslation from '../types/project/ProjectTranslation';
import Scale, { type ScaleValue } from '../types/project/360/Scale';

const Admin360ScaleService = {
    getTranslations,
    getScales,
    getScale,
    createScale,
    updateScale,
    patchValues,
};

const BASE_URL = '/admin/products/360/scales';

async function getScales(thunkApi?: GetThunkAPI<any>) {
    try {
        return await RequestService.get<Scale[]>(BASE_URL);
    } catch (e) {
        thunkApi?.dispatch(
            NotificationActions.error('nepodarilo se nacist skaly'),
        ); // TODO: translate

        throw e;
    }
}

async function getScale(
    payload: {
        scaleId: number;
    },
    thunkApi: GetThunkAPI<any>,
) {
    const { scaleId } = payload;
    try {
        return await RequestService.get<Scale>(`${BASE_URL}/${scaleId}`);
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se nacist skalu'),
        ); // TODO: translate

        throw e;
    }
}

async function createScale(
    payload: {
        name: string;
        primaryLanguage: string;
    },
    thunkApi: GetThunkAPI<any>,
) {
    const { name, primaryLanguage } = payload;
    try {
        return await RequestService.post<
            { name: string; primaryLanguage: string },
            Scale
        >(BASE_URL, {
            name,
            primaryLanguage,
        });
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se vytvorit skalu'),
        ); // TODO: translate

        throw e;
    }
}

async function updateScale(
    payload: {
        scaleId: number;
        name?: string;
        primaryLanguage?: string;
        description?: string;
        values?: ScaleValue[];
    },
    thunkApi: GetThunkAPI<any>,
) {
    const { scaleId, name, primaryLanguage, description, values } = payload;
    try {
        return await RequestService.patch<
            {
                name?: string;
                primaryLanguage?: string;
                description?: string;
                values?: ScaleValue[];
            },
            Scale
        >(`${BASE_URL}/${scaleId}`, {
            name,
            primaryLanguage,
            values,
            description,
        });
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se upravit skalu'),
        ); // TODO: translate

        throw e;
    }
}

async function patchValues(
    payload: {
        scaleId: number;
        values: ScaleValue[];
    },
    thunkApi: GetThunkAPI<any>,
) {
    const { scaleId, values } = payload;
    try {
        return await RequestService.patch<
            {
                values: ScaleValue[];
            },
            Scale
        >(`${BASE_URL}/${scaleId}`, {
            values,
        });
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se upravit hodnoty'),
        ); // TODO: translate

        throw e;
    }
}

async function getTranslations(
    _: void,
    thunkApi: GetThunkAPI<any>,
): Promise<RequestServiceResponse<ProjectTranslation[]>> {
    try {
        return await RequestService.get<any>(`${BASE_URL}`);
    } catch (e) {
        thunkApi.dispatch(
            NotificationActions.error('nepodarilo se nacist preklady'),
        ); // TODO: translate

        throw e;
    }
}

export default Admin360ScaleService;
